<!--
 * @Description: 柱状图组件
 * @Author: fengal
 * @Date: 2023-08-15 21:01:21
-->
<template>
  <div style="width: 100%; height: 300px"  :id="id" class="echarts" ref="echarts"></div>
</template>
<script>
export default {
  name: 'BarCharts',
  props: ['id', 'chartData'],
  data() {
    return {
    }
  },

  methods: {
    drawCharts() {
      let maxYAxis =  Math.ceil(this.chartData.amountChartMap.reduce((a, b) => a > b ? a : b));
      let chart = this.echarts.init(document.getElementById(this.id));
      chart.setOption({
        grid: {
            left: '30',
            right: '20',
            bottom: '60',
            containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          padding: [5, 18],
          borderColor: '#D7DDE5',
          borderWidth: 1,
          backgroundColor: "rgba(255,255,255,0.9000)", 
          textStyle : {
            color: '#333333' ,
            align:'left'
          },
          formatter:function(params){
            let relVal = '';
            relVal += `<div>${params[0].axisValue}</div>`;
            for (let i = 0, l = params.length; i < l; i++) { 
              relVal += params[i].seriesName + ':' + ' ' + params[i].value + '元'
            }
            return relVal;
          }
        },
        xAxis: [
          {
            type: 'category',
            data: this.chartData.xAxisData,
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: '#D7DDE5'
              }
            },
            axisLabel: {
              interval: 0,
              rotate: this.chartData.xAxisData.length > 10 ? 45 : 0,
              margin: 8,
              textStyle: {
                fontWeight: "normal",
                color: "#666666"
              }
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: '#3AC9EA'
              },
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            minInterval: 1,
            name: '元',
            nameTextStyle: {
              padding: [0, 0, 10, -35]
            },
            min: 0,
            max: maxYAxis,
            splitLine: {
                show: true,
                lineStyle: {
                    color: '#EAEEF5'
                }
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: '{value}'
            }
          },
        ],
        dataZoom: [
          {
            handleSize: 0,
            height: 5,
            left: 50,
            right: 40,
            bottom: 16,
            handleColor: '#ddd',
            handleStyle: {
              borderColor: "#cacaca",
              borderWidth: "1",
              shadowBlur: 2,
              background: "#ddd",
              shadowColor: "#ddd",
            },
            showDetail: false,
            fillerColor : '#A3A3A3',
            backgroundColor: '#ddd',
            showDataShadow: false,
            show: this.chartData.xAxisData.length > 14 ? true : false,
            xAxisIndex: [0],
            type: 'slider',
            startValue: 0,
            endValue: 14,
            zoomLock: true,
          },
          {
            type: 'inside',
            xAxisIndex: [0],
            start: 0,
            end: 14,
            zoomLock: true,
          },
        ],
        series: [
          {
            name: '收入',
            type: 'bar',
            barWidth : 15,
            itemStyle: {  
              normal: {  
                color: '#3E7EF5',
              }  
            },  
            data: this.chartData.amountChartMap,
          },
        ] 
      })
      window.addEventListener('resize', function () {
        chart.resize();
      });
    },
  },

  watch: {
    //子组件监听父组件数据实时更新
    chartData: {
      handler(_newValue, _oldValue) {
        this.drawCharts();
      },
      deep: true
    }
  },
  
  mounted() {
    this.drawCharts();
  }
}
</script>
<style scoped>
.register-trend-charts {
  height: 344px;
  border-radius: 6px;
  border: 1px solid #D7DDE5;
}
</style>



// WEBPACK FOOTER //
// src/components/report/components/BarCharts.vue